import {
  Card,
  CardBody,
  FunctionCard,
  Image,
  Paragraph,
  Separator,
  useMatchMediaTierProp,
} from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import OfferInfoComponent from "./OfferInfoPage"
import { OfferNavButtons } from "./OfferNavButtons"
import { OFFER_STEPS } from "./OfferStepper"

const IMAGE_URL = "./assets/celebration.png"

const OfferCelebration = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const headerTitle = t("offers.celebration.title")

  const textContent = (
    <Paragraph
      style={{
        marginBottom: "2rem",
      }}
    >
      {t("offers.celebration.text")}
    </Paragraph>
  )

  const nextButtonHandler = () => {
    navigate(`/offer/${OFFER_STEPS.Appointment}`, { replace: true })
  }

  const navButtonsContent = (
    <OfferNavButtons onNextButtonClicked={nextButtonHandler} />
  )

  const pageContent = useMatchMediaTierProp({
    xs: (
      <OfferInfoComponent
        buttonText={t("offers.button.next")}
        headerText={headerTitle}
        imageUrl={IMAGE_URL}
        onButtonClicked={nextButtonHandler}
        textContent={textContent}
      />
    ),
    md: (
      <Card nested={false}>
        <FunctionCard
          padding={Card.PADDING.LARGE}
          heading={headerTitle}
          indicator={<Image src={IMAGE_URL} alt="" />}
        >
          {textContent}
        </FunctionCard>

        <Separator />

        <CardBody>{navButtonsContent}</CardBody>
      </Card>
    ),
  })

  return <>{pageContent}</>
}

export default OfferCelebration
